import { Box } from '@mui/material';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@Components/Button';
import DateRangePicker from '@Components/DateRangePicker';
import MainSectionLayout from '@Components/MainSectionLayout';
import SearchBar from '@Components/SearchBar';

import DncLayoutProps from './DncLayout.types';

const DNCLayout: FunctionComponent<DncLayoutProps> = (
  props: DncLayoutProps
): JSX.Element => {
  const {
    searchProps,
    dateRangeProps,
    showFilterControls,
    selectedBtnNumber,
    selectedBtnProps,
    cancelBtnProps,
    deleteBtnProps,
    clearFilterBtnProps,
    exportBtnClick,
    dncAddBtnClick,
    exportAllClick,
    ...resProps
  } = props;

  /** Translation Hook */
  const { t } = useTranslation();

  /** Table Filters */
  const filtersComponent = (
    <>
      <Box
        display="flex"
        alignItems="center"
        flexWrap="wrap"
        gap={1.6}
        mb={1.6}
      >
        <SearchBar {...searchProps} maxWidth={33.3} />
        <Box minWidth={25.6} ml={2}>
          <DateRangePicker {...dateRangeProps} />
        </Box>

        <Button
          color="secondary"
          variant="outlined"
          icon="fileDownload"
          text={t('common.messages.Export All')}
          sx={{ ml: 'auto' }}
          onClick={exportAllClick}
        />
        <Button
          color="primary"
          icon="add"
          text={t('common.messages.Add Number')}
          sx={{ ml: 1.6 }}
          onClick={dncAddBtnClick}
        />
      </Box>
      {!!selectedBtnNumber && (
        <Box display="flex" alignItems="center" gap={0.8} my={1.6}>
          <Button
            variant="text"
            color="inherit"
            icon="checkboxFilled"
            iconColor="primary"
            text={`${selectedBtnNumber} ${t('common.messages.Selected')}`}
            sx={{ textTransform: 'none' }}
            {...selectedBtnProps}
          />
          <Button
            variant="text"
            color="inherit"
            icon="delete"
            text={t('common.messages.Delete')}
            sx={{ textTransform: 'none' }}
            {...deleteBtnProps}
          />
          <Button
            variant="text"
            color="inherit"
            icon="fileDownload"
            text={t('common.messages.Export')}
            sx={{ textTransform: 'none' }}
            onClick={exportBtnClick}
          />
          <Button
            variant="text"
            color="secondary"
            text={t('common.messages.Cancel')}
            {...cancelBtnProps}
          />
        </Box>
      )}
      {showFilterControls && (
        <Box
          display="inline-flex"
          alignItems="center"
          ml={selectedBtnNumber ? 0.8 : 0}
        >
          <Button
            variant="text"
            color="secondary"
            icon="close"
            text={t('common.tableFilters.Clear Filters')}
            sx={{ textTransform: 'none' }}
            {...clearFilterBtnProps}
          />
        </Box>
      )}
    </>
  );

  return <MainSectionLayout filters={filtersComponent} {...resProps} />;
};

export default DNCLayout;
